<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-4">
            <div class="card p-4">
              <div class="card-body">
                <h1>{{$t('LOGIN')}}</h1>
                <p class="text-muted">{{$t('LOGINTOYOURACCOUNT')}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><icon name="user"></icon></span>
                  <input type="text" v-model="username" class="form-control" v-bind:placeholder="$t('USERNAME')">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><icon name="lock"></icon></span>
                  <input type="password" v-model="password" class="form-control" v-bind:placeholder="$t('PASSWORD')">
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                  </div>
                  <div class="col-6">
                    <button type="button" v-on:click.prevent="login" class="btn btn-primary px-4">{{$t('LOGIN')}}</button>
                  </div>
                  <div class="col-6 text-right">
                    <button type="button" class="btn btn-link px-0">{{$t('FORGOTPASSWORD')}}</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <div>
                  <h2>{{$t('SIGNUP')}}</h2>
                  <p>{{$t('SIGNUPINTRO')}}</p>
                  <router-link class="btn btn-primary active mt-3" :to="{ path: '/register'}">{{$t('REGISTERNOW')}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'Login',
    data()
    {
        return { username: '', password: '' };
    },
    methods:
  {
      ...mapActions({
          actLogin: 'login',
      }),
      login(bvEvt)
      {
          bvEvt.preventDefault();
          this.actLogin({ username: this.username, password: this.password });
      },
  },
    computed:
  {
      ...mapGetters([
          'loginResponse',
      ]),
  },
};
</script>
